var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27584",
    "data-name": "Rectangle 27584",
    width: 38,
    height: 38,
    rx: 2,
    transform: "translate(709 643)",
    fill: "#676262"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_480",
    "data-name": "Mask Group 480",
    transform: "translate(-709 -643)",
    clipPath: "url(#pdf-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_62_",
    "data-name": "svgexport-6 (62)",
    transform: "translate(709.5 643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10688",
    "data-name": "Group 10688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11079",
    "data-name": "Path 11079",
    d: "M5.968,23.871H4.774A2.984,2.984,0,0,1,1.79,20.887a1.79,1.79,0,0,1,1.79-1.79H5.968v4.774Z",
    fill: "#bd4150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11080",
    "data-name": "Path 11080",
    d: "M28.645,0H6.565L5.95,1.194V36.422H34.016l1.194-.615V6.565Z",
    fill: "#eceaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11081",
    "data-name": "Path 11081",
    d: "M6.565,34.016V0A1.194,1.194,0,0,0,5.371,1.194V35.806A1.194,1.194,0,0,0,6.565,37H34.016a1.194,1.194,0,0,0,1.194-1.194H8.355a1.79,1.79,0,0,1-1.79-1.79Z",
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11082",
    "data-name": "Path 11082",
    d: "M35.21,6.462a1.194,1.194,0,0,0-.35-.844L29.591.35A1.194,1.194,0,0,0,28.747,0h-.1V5.968a.6.6,0,0,0,.6.6H35.21Z",
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11083",
    "data-name": "Path 11083",
    d: "M22.081,22.677H3.581a1.787,1.787,0,0,1-.6-.1l-.575.959v7.54a1.79,1.79,0,0,0,1.79,1.79H22.081l1.194-.639V23.871A1.193,1.193,0,0,0,22.081,22.677Z",
    fill: "#e15f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11084",
    "data-name": "Path 11084",
    d: "M2.984,22.575A1.8,1.8,0,0,1,1.79,20.887V31.629a1.79,1.79,0,0,0,1.79,1.79h18.5a1.194,1.194,0,0,0,1.194-1.194H4.774a1.79,1.79,0,0,1-1.79-1.79Z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10687",
    "data-name": "Group 10687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11085",
    "data-name": "Path 11085",
    d: "M18.822,27.407H17.65V26.276h1.324a.6.6,0,1,0,0-1.194H17.054a.6.6,0,0,0-.6.6v4.739a.6.6,0,0,0,1.194,0V28.6h1.171a.6.6,0,0,0,0-1.194Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11086",
    "data-name": "Path 11086",
    d: "M7.876,25.065H6.547a.6.6,0,0,0-.6.6h0v4.774a.6.6,0,0,0,1.194,0v-1.48l.733,0a1.944,1.944,0,1,0,0-3.888Zm0,2.694-.727,0c0-.275,0-1.5,0-1.5h.731a.751.751,0,1,1,0,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11087",
    "data-name": "Path 11087",
    d: "M12.881,25.135H11.569a.6.6,0,0,0-.6.6l0,2.31c0,.644.006,2.324.006,2.324a.6.6,0,0,0,.6.595h0s.973,0,1.349-.01a2.633,2.633,0,0,0,2.419-2.9C15.349,26.306,14.357,25.135,12.881,25.135Zm.028,4.623c-.171,0-.466.006-.735.007,0-.546,0-1.328,0-1.722l0-1.715h.714c1.213,0,1.275,1.433,1.275,1.72,0,.84-.385,1.695-1.247,1.71Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11088",
    "data-name": "Path 11088",
    d: "M14.3,20.188a1.383,1.383,0,0,1-1.169-.692,1.594,1.594,0,0,1,.313-2.084,9.2,9.2,0,0,1,3.519-1.787,30.69,30.69,0,0,0,1.457-3.2c.276-.707.5-1.345.677-1.915a6.914,6.914,0,0,1-1.129-3.654,1.525,1.525,0,0,1,1.768-1.328c.291.016.987.168,1.155,1.238a9.717,9.717,0,0,1-.52,3.645A22.7,22.7,0,0,0,23.411,14.4a7.456,7.456,0,0,1,3.771.446,1.2,1.2,0,0,1,.582,1.456,1.6,1.6,0,0,1-2.005,1.157,6.915,6.915,0,0,1-2.785-1.847,27.8,27.8,0,0,0-5.168.958c-.992,1.781-2.065,3.168-2.966,3.512a1.491,1.491,0,0,1-.535.1Zm-.168-1.34c.1.153.154.15.18.147.38-.039,1.013-.695,1.736-1.8a8.077,8.077,0,0,0-1.266.665c-.9.6-.712.894-.649.991ZM24.65,15.535a3.887,3.887,0,0,0,1.38.764c.309.072.469.035.6-.366C26.454,15.666,25.705,15.537,24.65,15.535Zm-4.74-3.68a32.548,32.548,0,0,1-1.384,3.327,29.02,29.02,0,0,1,3.423-.643,23.644,23.644,0,0,1-2.04-2.684Zm-.287-5.162c-.424,0-.446.159-.47.327a3.741,3.741,0,0,0,.4,1.791c.27-1.288.215-1.97.084-2.118h-.012Z",
    fill: "#e15f78"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.04d4722c9270de4e57d0c5f8c326e737.svg";
export { ForwardRef as ReactComponent };